module.exports = __webpack_public_path__ + "img/Image1.bdf68dc7.png";